import { solidAshColors as colors } from '~/theme/themes/colors/solidAshColors';
import { getSolidAsh } from './solidAsh';
import { getBase } from './base';


const themeSolidAsh = getSolidAsh();
const themeBase = getBase();

const accentColorPrimary = "#212B43";

// EXTENDED ON SOLIDASH
export const getBrothers = () => ({
    ...themeSolidAsh,
    colors: {
        ...colors,
        accentColorPrimary,
    },
    fonts: {
        headline: '"Open Sans","Open Sans fallback",serif',
        body: '"Open Sans","Open Sans fallback",serif',
        mono: 'monospace',
    },
    traits: {
        ...themeBase.traits,
        background: {
            ...themeBase.traits.background,
            n11meta: accentColorPrimary,
            n21mainMenu: colors.light30,
        },
    },
});
